import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pci-header',
    standalone: true,
    imports: [NavbarComponent, CommonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
    trayOpened = false;
    currentUrl = '';

    @Output() trayStateChanged = new EventEmitter<boolean>();

    private destroy$ = new Subject<void>();

    constructor(private router: Router) {}

    ngOnInit(): void {
        // Get initial URL
        this.currentUrl = this.router.url;

        // Subscribe to router events to detect URL changes
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
            )
            .subscribe((event: NavigationEnd) => {
                this.currentUrl = event.url;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    login() {
        this.trayOpened = false;
        this.trayStateChanged.emit(this.trayOpened);
        this.router.navigate(['/login']);
    }

    private emitTrayState(): void {
        this.trayStateChanged.emit(this.trayOpened);
    }

    toggleTray(): void {
        this.trayOpened = !this.trayOpened;
        this.emitTrayState();
    }

    onNavLinkClicked(): void {
        this.trayOpened = false;
        this.emitTrayState();
    }
}
